import moment from 'moment';

export const getLocalTimeAgo = time => moment.utc(time).local().fromNow();
